export default "__VITE_ASSET__DYP5Atl$__"